import React from 'react'
import { components } from 'react-select'
import { Col } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import type { SelectAsyncProps } from '@ztechapps/webui.input'
import { SelectAsync } from '@ztechapps/webui.input'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'
import { WorkOrderStatus } from '../WorkOrderStatus'

export const workOrderSelectFragment = gql`
  fragment workOrderSelectFragment on WorkOrder {
    _id
    status
    code
    product {
      _id
      code
    }
    quantity
  }
`

export const queries = buildGraphqlQuery('WorkOrder', workOrderSelectFragment)

//endregion

const Option = ({ data, ...rest }: any) => {
  const productCode = data?.product?.code
  const units = data?.quantity > 1 ? 'units' : 'unit'
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <HorizontalStack gap={2}>
        <div className="flex-shrink-0 text-nowrap">
          <HorizontalStack gap={0}>
            <WorkOrderStatus status={data?.status} />
            <div className="fw-bold">{data?.code}</div>
          </HorizontalStack>
        </div>

        <Col className="text-truncate">
          <ShowIf condition={!isEmpty(productCode)}>
            <small>{`${productCode} - [${data?.quantity} ${units}]`}</small>
          </ShowIf>
        </Col>
      </HorizontalStack>
    </components.Option>
  )
}

const dataLoadOptions = ({ filter }) => ({
  query: queries.allNoMetaConfig.query,
  filter: ({ input }) => ({
    $or: [{ code: { $regex: input, $options: 'i' } }],
    ...filter,
  }),
  resultFieldName: 'allWorkOrder',
  options: () => ({
    sort: { createdAt: -1 as const },
  }),
})

export const WorkOrderSelect = ({ filter, ...rest }: SelectAsyncProps) => {
  return (
    <SelectAsync
      {...{
        ...rest,
        components: { Option },
        placeholder: 'Type work order code',
        labelKey: 'code',
        // COUPLING: `noOptionsMessage` below must match `expectProductionOptionAbsent` in
        // apps/panelpunches/api-test/src/browser/support/page-objects/admin/LogisticItemPage.ts.
        noOptionsMessage: () => 'Cannot find any work orders.',
        dataLoadOptions: dataLoadOptions({ filter }),
      }}
    />
  )
}
